export const getCookieItem = key => {
  if (typeof window !== undefined && window.document) {
    const cookieItems = document.cookie.split('; ')

    return (cookieItems.filter(item => item.indexOf(key) > -1)[0] || '').split('=')[1]
  } else {
    return
  }
}